'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./MilanoteLogotype.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MilanoteLogotype = function MilanoteLogotype(props) {
    return _react2.default.createElement(
        'div',
        { className: 'MilanoteLogotype ' + props.className },
        _react2.default.createElement('img', { src: require('./milanote-logo.svg') }),
        _react2.default.createElement(
            'span',
            null,
            'Milanote'
        )
    );
};

MilanoteLogotype.propTypes = {
    className: _propTypes2.default.string,
    white: _propTypes2.default.bool
};

exports.default = MilanoteLogotype;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/MilanoteLogotype.js
// module id = 703
// module chunks = 0